// import format from "date-fns/format";
// import getDay from "date-fns/getDay";
// import parse from "date-fns/parse";
// import startOfWeek from "date-fns/startOfWeek";

import './stylecalendar.css'
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";


import React, { useState, useEffect } from "react";

import Cookies from "js-cookie";

import { Circles } from "react-loader-spinner";

import {
  Calendar,
  // dateFnsLocalizer,
  momentLocalizer,
} from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import moment from "moment";
import "moment-timezone"; // or 'moment-timezone/builds/moment-timezone-with-data[-datarange].js'. See their docs

import RecordsDashboard from "./RecordsDashboard";

// Set the IANA time zone you want to use
moment.tz.setDefault("Nairobi/Kenya");

// Setup the localizer by providing the moment Object
// to the correct localizer.
const localizer = momentLocalizer(moment); // or globalizeLocalizer



// let events = [

// ];

function RecordsCalender() {
   const [foundErr, setFoundErr] = useState(null);
  const [isLoading, setIsLoading] = useState(null);

  const [records, setRecords] = useState([]);

  const [downloadPeriod, setDownloadPeriod] = useState("full");

  const [customStartDate, setCustomStartDate] = useState(null);
  const [customEndDate, setCustomEndDate] = useState(new Date());

  const [newEvent, setNewEvent] = useState({
  title: "",
  start: null,
  end: null,
});

  // NOW use records

  // const [allEvents, setAllEvents] = useState(events);
  // const [allEvents, setAllEvents] = useState([]);

  // const [eventsAI, setEventsAI] = useState([]);

  // function handleAddEvent() {
  //   for (let i = 0; i < allEvents.length; i++) {
  //     const d1 = new Date(allEvents[i].start);
  //     const d2 = new Date(newEvent.start);
  //     const d3 = new Date(allEvents[i].end);
  //     const d4 = new Date(newEvent.end);
  //     /*
  //         console.log(d1 <= d2);
  //         console.log(d2 <= d3);
  //         console.log(d1 <= d4);
  //         console.log(d4 <= d3);
  //           */

  //     if ((d1 <= d2 && d2 <= d3) || (d1 <= d4 && d4 <= d3)) {
  //       alert("CLASH");
  //       break;
  //     }
  //   }

  //   // setAllEvents([...allEvents, newEvent]);

  //   //refresh data
  //   refreshRecords();
  // }


  const handleRefreshRecords = () => {
  fetchRecords();
};
  const productColors = {
  milk: "#3b82f6",     // blue
  coffee: "#ef4444",   // red
  'tea leaves': "#10b981",      // green
};

const eventStyleGetter = (event) => {
  return {
    style: {
      backgroundColor: event.color,
      borderRadius: "6px",
      color: "white",
      border: "none",
      padding: "2px",
    },
  };
};

//   const events = records.map((r) => {
//   const type = (r.producttype || "").toLowerCase();

//   return {
//     id: r.id,
//     title: `${r.weight} - ${r.producttype}`,
//     start: new Date(r.daterecorded),
//     end: new Date(r.daterecorded),
//     allDay: true,
//     resource: r,
//     color: productColors[type] || "#6b7280",
//   };
// });



// const calendarEvents = records.map((record) => {
//   const type = (record.producttype || "").toLowerCase();

//   return {
//     id: record.id,
//     title: `${record.weight}kg ${record.producttype}`,
//     start: new Date(record.daterecorded),
//     end: new Date(record.daterecorded),
//     allDay: true,
//     resource: record,
//     color: productColors[type] || "#6b7280",
//   };
// });



const calendarEvents = records.map((record) => {
  const type = (record.producttype || "").toLowerCase();

  return {
    id: record.id,
    title: `${record.weight}kg ${record.producttype}`,
    start: moment(record.daterecorded).toDate(),
    end: moment(record.daterecorded).toDate(),
    allDay: true,
    color: productColors[type] || "#6b7280",
  };
});


  useEffect(() => {
    //fetch agents
    const fetchAll = () => {
      let adminCookie = Cookies.get("sessioniduser");
      if (adminCookie.length >= 1) {
        setIsLoading(true);

        setTimeout(() => {
          fetch("https://api.terraweb.africa/getRecords", {
            method: "post",
            headers: { "Content-Type": "application/JSON" },
            body: JSON.stringify({
              userid: adminCookie,
            }),
          })
            .then(function (response) {
              if (response.status === 400) {
                throw Error("Wrong credentials");
              }
              if (response === 500) {
                throw Error("Could not complete request because of an error");
              }

              return response.json();
            })
        .then((data) => {

  console.log("Calendar API:", data);

  if (data?.records) {
    setRecords(data.records);
  } else {
    setRecords([]);
  }

  setFoundErr(null);
  setIsLoading(false);
})
            .catch((err) => {
              // setFoundErr(err.message);
              setIsLoading(null);
              // setFlag(1);
            });
        }, 2000);
      } else {
        setIsLoading(null);
      }
    };

    fetchAll();
  }, []);



  //fetch records
  const fetchRecords = () => {
    let adminCookie = Cookies.get("sessioniduser");
    if (adminCookie.length >= 1) {
      setIsLoading(true);

      setTimeout(() => {
        fetch("https://api.terraweb.africa/getRecords", {
          method: "post",
          headers: { "Content-Type": "application/JSON" },
          body: JSON.stringify({
            userid: adminCookie,
          }),
        })
          .then(function (response) {
            if (response.status === 400) {
              throw Error("Wrong credentials");
            }
            if (response === 500) {
              throw Error("Could not complete request because of an error");
            }

            return response.json();
          })
      .then((data) => {

  console.log("Calendar API:", data);

  if (data?.records) {
    setRecords(data.records);
  } else {
    setRecords([]);
  }

  setFoundErr(null);
  setIsLoading(false);
})
          .catch((err) => {
            // setFoundErr(err.message);
            setIsLoading(null);
            // setFlag(1);
          });
      }, 5000);
    } else {
      setIsLoading(null);
    }
  };

  //refresh after add records
  const refreshRecords = () => {
    fetchRecords();
  };

  const getCompanyInitials = (name = "") => {
  return name
    .split(" ")
    .map(w => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
};

  const handleDownloadTable = async () => {
  const doc = new jsPDF();

  const filteredRecords = getFilteredRecords();
  // const currentDate = new Date().toLocaleString();
  const currentDate = new Date().toISOString().replace("T", " ").split(".")[0];

  // Example: derive company info (adjust if you already store profile)
  // const companyName = filteredRecords?.[0]?.companyname || "Terraweb";
  // const companyName =
  // filteredRecords?.company || "Terraweb";

  const companyName =
  filteredRecords?.[0]?.companyname ||
  records?.[0]?.companyname ||
  "Terraweb";
  
  const initials = getCompanyInitials(companyName);

  const getBase64ImageFromUrl = async (url) => {
  const res = await fetch(url);
  const blob = await res.blob();

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};

  // const favicon = "/favicon.ico"; // or base64 version (recommended)
  // const faviconBase64 = "data:image/png;base64,...."; // your converted icon

  const faviconBase64 = await getBase64ImageFromUrl("/img/LOGO-FAVCON.png");
  // =========================
  // HEADER (Professional)
  // =========================

  // Company badge (2-letter "SVG-like" circle)
const badgeX = 180;
const badgeY = 5;
const badgeSize = 16;

doc.setFillColor(252, 156, 28);
doc.roundedRect(
  badgeX,
  badgeY,
  badgeSize,
  badgeSize,
  3,
  3,
  "F"
);

doc.setFont("helvetica", "bold");
doc.setFontSize(18);
doc.setTextColor(255, 255, 255);

const textWidth = doc.getTextWidth(initials);

doc.text(
  initials,
  badgeX + (badgeSize / 2) - (textWidth / 2),
  badgeY + 11
);

doc.setTextColor(0, 0, 0);

  doc.setFontSize(11);
  doc.setFont("helvetica", "normal");
  // doc.text("Empowering farmers through technology", 14, 23);

  // Account Profile section
  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  // doc.text("Account Profile:", 14, 32);

  doc.setFont("helvetica", "bold");
  doc.text(`Company: ${companyName}`, 14, 38);
  doc.text(`Generated: ${currentDate}`, 14, 44);

  // Account Information (expandable section)
  doc.setFont("helvetica", "bold");
  // doc.text("Account Information:", 14, 52);

  doc.setFont("helvetica", "normal");
  doc.text(`Total Records: ${filteredRecords?.length || 0}`, 14, 58);

  // =========================
  // TABLE
  // =========================

  const tableColumn = [
    "ID",
    "Farmer ID",
    "Product Type",
    "Weight",
    "Company",
    "Full Name",
    "Added by",
    "Recorded Date",
  ];

  // const tableRows =
  //   filteredRecords?.map((contact) => [
  //     contact.id,
  //     contact.farmerid,
  //     contact.producttype,
  //     contact.weight,
  //     contact.companyname,
  //     contact.fullname,
  //     contact.added_by || "Admin", // ✅ NEW: clerk included
  //     contact.daterecorded,
  //   ]) || [];

  const tableRows = filteredRecords.map((r) => [
  r.id,
  r.farmerid,
  r.producttype,
  r.weight,
  r.companyname,
  r.fullname,
  r.added_by || r.username || "system",
  r.daterecorded,
]);

  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 65,
    styles: {
      fontSize: 9,
      cellPadding: 3,
      textColor: [0, 0, 0],
    },
    headStyles: {
      fillColor: [252, 156, 28],
      textColor: [0, 0, 0],
      fontStyle: "bold",
    },
    alternateRowStyles: {
      fillColor: [245, 245, 245],
    },
    margin: { top: 60, bottom: 25 },

   didDrawPage: function (data) {
  const pageCount = doc.internal.getNumberOfPages();
  const page = doc.internal.getCurrentPageInfo().pageNumber;

  const pageHeight = doc.internal.pageSize.height;
  const pageWidth = doc.internal.pageSize.width;

  // =========================
  // FAVICON
  // =========================
  const iconSize = 8;

  // only draw if base64 available
  if (faviconBase64) {
    doc.addImage(
      faviconBase64,
      "PNG",
      14,
      pageHeight - 16,
      iconSize,
      iconSize
    );
  }

  // =========================
  // FOOTER TEXT
  // =========================
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");

  doc.text(
    "Terraweb.africa — Empowering through technology",
    25,
    pageHeight - 10
  );

  // =========================
  // COPYRIGHT + PAGE
  // =========================
  doc.setFont("helvetica", "bold");

  // doc.text(
  //   `© 2026 All Rights Reserved`,
  //   pageWidth - 90,
  //   pageHeight - 10
  // );

doc.text(
  `Page ${page} of ${pageCount}`,
  pageWidth - 15,
  pageHeight - 10,
  { align: "right" }
);
}
  });
const safeDate = new Date()
  .toISOString()
  .replace(/T/, "_")
  .replace(/:/g, "-")
  .split(".")[0];

const fileName = `${companyName}_farmer_records_${safeDate}.pdf`;

doc.save(fileName);
};

  // const handleDownloadTable = () => {
  //   const filteredRecords = getFilteredRecords();

  //   if (filteredRecords.length === 0) {
  //     alert("No records found for selected period");
  //     return;
  //   }

  //   const doc = new jsPDF();

  //   const currentDate = new Date().toLocaleString();

  //   // Header
  //   doc.setFontSize(16);
  //   doc.text("Terraweb.africa", 14, 15);

  //   doc.setFontSize(11);
  //   doc.text("Empowering farmers through technology", 14, 22);

  //   doc.setFontSize(10);
  //   doc.text(`Generated on: ${currentDate}`, 14, 28);

  //   // Table columns
  //   const tableColumn = [
  //     "ID",
  //     "Farmer ID",
  //     "Product Type",
  //     "Weight",
  //     "Company",
  //     "Full Name",
  //     "Recorded",
  //   ];

  //   // Table rows
  //   const tableRows = filteredRecords.map((contact) => [
  //     contact.id,
  //     contact.farmerid,
  //     contact.producttype,
  //     contact.weight,
  //     contact.companyname,
  //     contact.fullname,
  //     contact.daterecorded,
  //   ]);

  //   autoTable(doc, {
  //     head: [tableColumn],
  //     body: tableRows,
  //     startY: 35,
  //     styles: {
  //       fontSize: 9,
  //       textColor: [0, 0, 0],
  //     },
  //     headStyles: {
  //       fillColor: [252, 156, 28],
  //     },
  //     margin: {
  //       top: 35,
  //       bottom: 20,
  //     },

  //     didDrawPage: function (data) {
  //       const pageCount = doc.internal.getNumberOfPages();

  //       doc.setFontSize(9);

  //       doc.text(
  //         `Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`,
  //         data.settings.margin.left,
  //         doc.internal.pageSize.height - 10
  //       );

  //       doc.text(
  //         "© Terraweb.africa — All rights reserved.",
  //         data.settings.margin.left + 70,
  //         doc.internal.pageSize.height - 10
  //       );
  //     },
  //   });
  //   const timestamp = new Date()
  //     .toISOString()
  //     .replace(/[:.]/g, "-");

  //   doc.save(`terraweb-farmerdata-${timestamp}.pdf`);
  // };


  // const getFilteredRecords = () => {
  //   if (downloadPeriod === "full") {
  //     return records;
  //   }

  //   return records.filter((record) => {
  //     const recordDate = new Date(record.daterecorded);

  //     // return (
  //     //   customStartDate &&
  //     //   customEndDate &&
  //     //   recordDate >= customStartDate &&
  //     //   recordDate <= customEndDate
  //     // );


  //     return (
  //       customStartDate &&
  //       customEndDate &&
  //       recordDate >= customStartDate &&
  //       recordDate <= new Date(customEndDate.setHours(23, 59, 59, 999))
  //     );
  //   });
  // };

  const getFilteredRecords = () => {
  const now = new Date();

  if (downloadPeriod === "full") return records;

  if (downloadPeriod === "month") {
    return records.filter((r) => {
      const d = new Date(r.daterecorded);
      return (
        d.getMonth() === now.getMonth() &&
        d.getFullYear() === now.getFullYear()
      );
    });
  }

  if (downloadPeriod === "custom") {
    if (!customStartDate || !customEndDate) return [];

    return records.filter((r) => {
      const d = new Date(r.daterecorded);
      // return (
      //   d >= customStartDate &&
      //   d <= new Date(customEndDate.setHours(23, 59, 59, 999))
      // );
      const endDate = new Date(customEndDate);
endDate.setHours(23, 59, 59, 999);

return (
  d >= customStartDate &&
  d <= endDate
);
    });
  }

  return records;
};

const monthlyTotals = records.reduce((acc, r) => {
  const month = new Date(r.daterecorded).getMonth();
  acc[month] = (acc[month] || 0) + parseFloat(r.weight || 0);
  return acc;
}, {});



  return (
    <div className="Apppp bg-white pa4 mt6 w-80-l center">
      {/* PAGE HEADER */}


      {/* FILTER + ACTIONS SECTION */}
      <div className="bg-near-white br4 shadow-2 pa4 mb5">
        
  
        {/* stats section */}

        <RecordsDashboard />


 {/* LOADER */}
            {isLoading ? (
              <div className="mt3">
                <Circles
                  type="Oval"
                  color="#1b1b1b"
                  height={40}
                  width={40}
                />
              </div>
            ) : null}

            {/* ERROR */}
            {foundErr ? (
              <label className="db red mt3 fw6">
                {foundErr}
              </label>
            ) : null}

      </div>
      {/* <Calendar
        localizer={localizer}
        events={allEvents}
        startAccessor="start"
        endAccessor="end"
        style={{
          height: 550,
          marginTop: "20px",
          backgroundColor: "white",
          padding: "10px",
          borderRadius: "12px",
        }}
      /> */}

      <div className="flex flex-wrap justify-center mb4">

  {Object.entries(monthlyTotals).map(([month, total]) => (
    <div
      key={month}
      className="bg-white shadow-1 br3 pa3 ma2 tc"
      style={{ minWidth: "140px" }}
    >
      <div className="f6 gray">
        {moment()
          .month(month)
          .format("MMMM")}
      </div>

      <div className="f3 fw6 green">
        {Number(total).toFixed(2)} kg
      </div>
    </div>
  ))}

</div>

<div className="overflow-x-auto">
  <div className="mw-none" style={{ minWidth: "950px" }}>

  
      <Calendar
  localizer={localizer}
  // events={events}
    events={calendarEvents}
  startAccessor="start"
  endAccessor="end"
  eventPropGetter={eventStyleGetter}
  style={{
    height: 550,
    marginTop: "20px",
    backgroundColor: "white",
    padding: "10px",
    borderRadius: "12px",
  }}
/>
</div>
</div>
      <div className="bg-near-white br4 shadow-2 pa4 mb5">


 {/* TOP GRID */}
       
  
        {/* DOWNLOAD SECTION */}
        <div className="flex flex-column flex-row-l items-start items-end-l justify-between">

          {/* LEFT SIDE */}
          <div className="w-100 w-70-l">

            <h3 className="f4 fw6 near-black ma0 mb3">
              Download Farmer Records
            </h3>

            <div className="flex flex-column flex-row-l flex-wrap items-start">

              {/* PERIOD SELECT */}
              <div className="mr3 mb3">
                <label className="db mb2 fw6 gray f6">
                  Export Period
                </label>

                <select
                  className="
              pa2
              br3
              ba
              b--light-silver
              bg-white
              dark-gray
              outline-0
              w5
            "
                  value={downloadPeriod}
                  onChange={(e) =>
                    setDownloadPeriod(e.target.value)
                  }
                >

                  <option value="full">
                    Full Records
                  </option>

                  <option value="month">
  Current Month
</option>

                  <option value="custom">
                    Custom Range
                  </option>
                </select>
              </div>

              {/* CUSTOM DATES */}
              {downloadPeriod === "custom" && (
                <>
                  {/* FROM */}
                  <div className="mr3 mb3">
                    <label className="db mb2 fw6 gray f6">
                      From
                    </label>

                    <DatePicker
                      selected={customStartDate}
                      onChange={(date) =>
                        setCustomStartDate(date)
                      }
                      placeholderText="Start Date"
                      className="
                  pa2
                  br3
                  ba
                  b--light-silver
                  bg-white
                  dark-gray
                  outline-0
                  w5
                "
                    />
                  </div>

                  {/* TO */}
                  <div className="mr3 mb3">
                    <label className="db mb2 fw6 gray f6">
                      To
                    </label>

                    <DatePicker
                      selected={customEndDate}
                      onChange={(date) =>
                        setCustomEndDate(date)
                      }
                      placeholderText="End Date"
                      className="
                  pa2
                  br3
                  ba
                  b--light-silver
                  bg-white
                  dark-gray
                  outline-0
                  w5
                "
                    />
                  </div>
                </>
              )}
            </div>
          </div>

          {/* DOWNLOAD BUTTON */}
          <div className="mt4 mt0-l">
            <button
              onClick={handleDownloadTable}
              className="
          pointer
          bn
          br-pill
          white
          bg-dark-green
          hover-bg-green
          pa3
          ph4
          fw6
          shadow-1
          dim
          transition
        "
            >
              ⬇ Download PDF
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecordsCalender;
